const Routes = [];

/*** PUBLIC RULES */
Routes.push({
    path: "/m-audiences",
    meta: {},
    name: "m-audiences",
    component: () => import("@/modules/maudiences/RootView")
});

export default Routes;